// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KD-z","hovered":"LD-z","hoverImage":"MD-z","mainImage":"ND-z","imageNoBackground":"OD-z","fullSizeImage":"PD-z"};